import React from 'react';
import twelve from '../assets/twelve_display.png';

const Slide3 = (props) => {
    return (
        <>
        <div className='slide3-main'>
            <div className='slide3-outer'>
                <div className='slide3-box'>
                    <div className='slide3-textbox'>
                        <div className='slide3-title'>
                            Reward
                        </div>
                        <div className='slide3-description'>
                            Present your Pouch to the server to enjoy your reward
                        </div>
                    </div>
                </div>
            </div>
            
            <div className='slide3-image-box'>
                <img src={twelve} style={{height: "80%"}} alt="Image3"/>
            </div>
            
        </div>

        <style jsx>{`
                .slide3-main {
                    display: flex;
                    width: 1000px;
                    flex-direction: row;
                    align-items: center;
                    position: absolute;
                    opacity: ${props.active ? 1 : 0};
                    transition: opacity 0.5s ease-in;
                }
                .slide3-outer {
                    display: flex;
                    flex-direction: column;
                }
                .slide3-box {
                    display: flex;
                    flex-direction: row;
                    height: 250px;
                    width: 1100px;
                    border-radius: 200px;
                    color: white;
                    background-color: ${props.color};
                    justify-content: center;
                    align-items: center;    
                }
                .slide3-textbox {
                    padding-top: 50px;
                    padding-bottom: 50px;
                    padding-left: 120px;
                    padding-right: 300px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
                .slide3-title {
                    font-weight: 600;
                    font-size: 48px;
                    color: #fffefb;
                    margin-bottom: 10px;
                }
                .slide3-description {
                    font-size: 36px;
                    color: #fffefb;
                }
                .slide3-image-box {
                    transform: translateX(-300px);
                    width: 450px;
                    height: 600px;
                    z-index: 1;
                }
            `}</style>
        </>
    )
}

export default Slide3;